import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '../assets/img/navlogo.svg';
import uslogo from '../assets/img/Ellipse 1840.png';
import flag from '../assets/img/Ellipse 1841.png';
import { LanguageContext } from './languagecontext';
import API from '../pages/Services/Baseservice';
import { slugify } from '../utils/slugify';
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedLanguage, handleSelect } = useContext(LanguageContext);
  const [DropDown, setDropDown] = useState([]);
  const [loading, setLoading] = useState(true);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const servicesTimeoutRef = useRef(null);
  const resourcesTimeoutRef = useRef(null);
  const [activeNav, setActiveNav] = useState('');
  const [languageList, setLanguageList] = useState("")
  const navRef = useRef(null);
  const togglerRef = useRef(null);
  const prevLanguageRef = useRef(selectedLanguage.id);
  useEffect(() => {
    const prevLang = prevLanguageRef.current;
    const currentLang = selectedLanguage.id;
    if (
      prevLang &&
      prevLang !== currentLang &&
      location.pathname === "/bookingintakeform"
    ) {
      navigate("/bookingform", { replace: true });
    }

    prevLanguageRef.current = currentLang;
  }, [selectedLanguage.id, location.pathname, navigate]);



  useEffect(() => {
    if (selectedLanguage?.id) {
      dropdown();
    }
  }, [selectedLanguage.id]);

  useEffect(() => {
    updateActiveNav();
  }, [location.pathname, DropDown]);

  const dropdown = () => {
    setLoading(true);
    let req = { language_id: selectedLanguage.id };

    API.post("weblistofservice_list/webCondition", req)
      .then((res) => {
        if (res.data.success === true) {
          const services = (res.data.data.data).slice().sort((a, b) => Number(a.order_by) - Number(b.order_by));
          setDropDown(services);
          localStorage.setItem("DropDownValue", JSON.stringify(services));
        }
      })
      .finally(() => setLoading(false));
  };

const handleClick = (item) => {
  if (item.listofservice_id) {
    const slug = slugify(item.heading);
    navigate(`/servicedetail/${slug}`, {
      state: {
        id: item.listofservice_id,
        language_id: selectedLanguage.id,
      },
    });
  } else {
    console.log("No route defined for:", item.listofservice_id);
  }
};

  useEffect(() => {
    const handleOutsideTouch = (e) => {

      if (window.innerWidth >= 1200) return;

      if (
        navRef.current &&
        !navRef.current.contains(e.target) &&
        togglerRef.current &&
        !togglerRef.current.contains(e.target)
      ) {
        closeAllMenus();
      }
    };

    document.addEventListener("touchstart", handleOutsideTouch);
    document.addEventListener("mousedown", handleOutsideTouch);

    return () => {
      document.removeEventListener("touchstart", handleOutsideTouch);
      document.removeEventListener("mousedown", handleOutsideTouch);
    };
  }, []);


  const updateActiveNav = () => {
    const path = location.pathname;

    const isServicePage = path === '/expressentry' ||
      path === '/service' ||
      (DropDown.some(item =>
        location.state?.id === item.listofservice_id
      ));
    const isResourcePage = path === '/faq' ||
      path === '/blog' ||
      path === '/news';

    if (path === '/') {
      setActiveNav('home');
    } else if (path === '/aboutus') {
      setActiveNav('about');
    } else if (isServicePage) {
      setActiveNav('services');
    } else if (isResourcePage) {
      setActiveNav('resources');
    } else if (path === '/contactus') {
      setActiveNav('contactus');
    } else {
      setActiveNav('');
    }
  };

  const handleServicesMouseEnter = () => {
    if (servicesTimeoutRef.current) {
      clearTimeout(servicesTimeoutRef.current);
    }
    setServicesOpen(true);
  };

  const handleServicesMouseLeave = () => {
    servicesTimeoutRef.current = setTimeout(() => {
      setServicesOpen(false);
    }, 0);
  };

  const handleResourcesMouseEnter = () => {
    if (resourcesTimeoutRef.current) {
      clearTimeout(resourcesTimeoutRef.current);
    }
    setResourcesOpen(true);
  };

  const handleResourcesMouseLeave = () => {
    resourcesTimeoutRef.current = setTimeout(() => {
      setResourcesOpen(false);
    }, 0);
  };

  const handleServicesClick = () => {
    navigate("/service");
    setServicesOpen(false);
  };

  const isServiceItemActive = (item) => {
    return location.pathname === '/expressentry' &&
      location.state?.id === item.listofservice_id;
  };

  const isResourcesItemActive = (path) => {
    return location.pathname === path;
  };


  const webLanguageList = () => {
    API.post("weblanguage_list/webCondition").then((res) => {
      if (res.data.success === true) {
        setLanguageList(res.data.data.data)

      }

    })

  }

  useState(() => {
    webLanguageList()
  }, [])
  useEffect(() => {
    closeAllMenus();
  }, [location.pathname]);

  const closeAllMenus = () => {
    setServicesOpen(false);
    setResourcesOpen(false);

    const navbar = document.getElementById("navbarNav");
    const toggler = document.querySelector(".navbar-toggler");

    if (navbar?.classList.contains("show")) {
      navbar.classList.remove("show");
    }

    if (toggler) {
      toggler.classList.add("collapsed");
      toggler.setAttribute("aria-expanded", "false");
    }
  };

  const handleDropdownToggle = (e, type) => {
    e.preventDefault();
    if (type === 'services') {
      setServicesOpen(!servicesOpen);
      setResourcesOpen(false);
    } else if (type === 'resources') {
      setResourcesOpen(!resourcesOpen);
      setServicesOpen(false);
    }
  };
  const handleLanguage = (item) => {
    sessionStorage.removeItem("booking_step1_data");
    localStorage.removeItem("booking_step1_data");
    localStorage.removeItem("booking_step2_data");
    sessionStorage.removeItem("booking_step2_data");
    handleSelect({
      name: item.language,
      icon: item.flag_iamge,
      id: item.language_id
    });

    closeAllMenus();
  };

  const handleNavAway = (path) => {
    if (
      location.pathname === "/bookingform" ||
      location.pathname === "/bookingintakeform"
    ) {
      sessionStorage.removeItem("booking_step1_data");
      sessionStorage.removeItem("booking_step2_data");
    }

    navigate(path);
  };

  return (
    <nav className="navbar navbar-expand-xl fixed-top navbar-light pt-3">
      <div className="container px-3">
        <a
          className="navbar-brand d-flex align-items-center"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleNavAway('/');
          }}
          style={{ cursor: 'pointer' }}
        >
          <img src={Logo} alt="Asra Logo" />
        </a>

        <button
          ref={togglerRef}
          className="navbar-toggler collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          ref={navRef}
          className="collapse navbar-collapse"
          id="navbarNav"
        >

          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a
                className={`nav-link ${activeNav === 'home' ? 'active' : ''}`}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavAway('/');
                  closeAllMenus();
                }}
                style={{ cursor: 'pointer' }}
              >
                {selectedLanguage.id === 1 ? 'Home' : 'Accueil'}
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${activeNav === 'about' ? 'active' : ''}`}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavAway('/aboutus');
                  closeAllMenus();
                }}
                style={{ cursor: 'pointer' }}
              >
                {selectedLanguage.id === 1 ? 'About Us' : 'À propos de nous'}
              </a>
            </li>

            <li
              className="nav-item dropdown me-2"
              onMouseEnter={handleServicesMouseEnter}
              onMouseLeave={handleServicesMouseLeave}
            >
              <div className="nav-link-wrapper">
                <a
                  href="#"
                  className={`nav-link pe-1 m-0 ${activeNav === 'services' ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAway('/service');
                    closeAllMenus();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Services
                </a>

                <button
                  className="btn btn-sm p-0 dropdown-toggle-icon"
                  type="button"
                  onClick={(e) => handleDropdownToggle(e, 'services')}
                  aria-expanded={servicesOpen}
                  aria-label="Open services menu"
                >
                  <i className="bi bi-caret-down-fill"></i>
                </button>
              </div>

              <ul className={`dropdown-menu ${servicesOpen ? 'show' : ''}`}>
                {DropDown && DropDown.length > 0 && DropDown.map((item, index) => (
                  <li key={index}>
                    <a
                      className={`dropdown-item ${isServiceItemActive(item) ? 'active' : ''}`}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick(item);
                        closeAllMenus();
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {item.heading}
                    </a>
                  </li>
                ))}
              </ul>
            </li>

            <li
              className="nav-item dropdown me-2"
              onMouseEnter={handleResourcesMouseEnter}
              onMouseLeave={handleResourcesMouseLeave}
            >
              <div className="nav-link-wrapper dropdown-toggle-icon">
                <a
                  className={`nav-link pe-1 m-0 ${activeNav === 'resources' ? 'active' : ''}`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    closeAllMenus();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {selectedLanguage.id === 1 ? 'Resources' : 'Ressources'}
                </a>

                <button
                  className="btn btn-sm p-0 dropdown-toggle-icon"
                  type="button"
                  onClick={(e) => handleDropdownToggle(e, 'resources')}
                  aria-expanded={resourcesOpen}
                  aria-label="Open resource menu"
                >
                  <i className="bi bi-caret-down-fill"></i>
                </button>
              </div>

              <ul className={`dropdown-menu ${resourcesOpen ? 'show' : ''}`} id="resource-dropdown">
                <li>
                  <a
                    className={`dropdown-item ${isResourcesItemActive('/faq') ? 'active' : ''}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavAway('/faq');
                      closeAllMenus();
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    FAQ
                  </a>
                </li>
                <li>
                  <a
                    className={`dropdown-item ${isResourcesItemActive('/blog') ? 'active' : ''}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavAway('/blog');
                      closeAllMenus();
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {selectedLanguage.id === 1 ? 'Blog' : 'Blogue'}
                  </a>
                </li>
                <li>
                  <a
                    className={`dropdown-item ${isResourcesItemActive('/news') ? 'active' : ''}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavAway('/news');
                      closeAllMenus();
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {selectedLanguage.id === 1 ? 'News' : 'Nouvelles'}
                  </a>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${activeNav === 'contactus' ? 'active' : ''}`}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/contactus');
                  closeAllMenus();
                }}
                style={{ cursor: 'pointer' }}
              >
                {selectedLanguage.id === 1 ? 'Contact Us' : 'Contactez-nous'}
              </a>
            </li>
          </ul>

          <div className="dropdown d-flex flex-column  justify-content-center align-items-center my-2">
            <button
              className="btn btn-light dropdown-togglee d-flex align-items-center"
              type="button"
              id="langDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src={selectedLanguage.icon}
                alt={selectedLanguage.name}
                className="flag-icon me-2 rounded-circle"
              />
              <i className="bi bi-caret-down-fill"></i>
            </button>

            <ul className="dropdown-menu" aria-labelledby="langDropdown" id="flag-dropdown">
              {Array.isArray(languageList) && languageList.length > 0 ? languageList.map((item, index) => (
                <li className="cursorpointer" onClick={() => handleLanguage(item)}><a class="dropdown-item d-flex align-items-center justify-content-center" ><img src={item.flag_iamge} alt="English" class="flag-icon me-2 rounded-circle " />{item.language}</a>
                </li>
              )) : (null)}
            </ul>
          </div>

          <div className="btn-pair">
            <a
              className="nav-link"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleNavAway('/checkeligibility');
                closeAllMenus();
              }}
              style={{ cursor: 'pointer' }}
            >
              <button className="btn btn-outline-dark">
                {selectedLanguage.id === 1 ? 'Check Eligibility' : 'Vérifier l\'éligibilité'}
              </button>
            </a>

            <a
              className="nav-link"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate('/bookingform');
                closeAllMenus();
              }}
              style={{ cursor: 'pointer' }}
            >
              <button className="btn btn-danger d-flex align-items-center justify-content-center">
                <p className="p-0 m-0">
                  {selectedLanguage.id === 1 ? 'Book a Consultation' : 'Réserver une consultation'}
                </p>
                <i className="bi bi-arrow-right-circle-fill ms-1 book-icon"></i>
              </button>
            </a>
          </div>

          <hr className="mobile-divider d-lg-none" />
        </div>
      </div>
    </nav>
  );
};

export default Header;